// @flow
import React, { type Node } from 'react';

import { Sections } from 'Components/frameworks/sections/Sections.jsx';

type Props = {
  children: Node,
  config: CMSContent,
  lines: Array<*>,
};

export function SectionsLine({
  children,
  config: {
    common: { scrollBackward, scrollForward },
  },
  lines = [],
}: Props) {
  return (
    <Sections
      navItems={lines.map(l => l.props.name)}
      scrollBackwardLabel={scrollBackward}
      scrollForwardLabel={scrollForward}
    >
      {children}
    </Sections>
  );
}
